<template>
  <div class="modal-content ion-padding ion-text-center">
    <modal-close />
    <roodie fillOuter="#5E58BE" :expression="'happy'" />
    <div class="u-color-primary u-bold">
      <div class="u-medium ion-margin-top">
        Medgate Arztgespräch
      </div>
      <div class="u-xxlarge ion-margin-top">
        08959 - 123456<br />
        <ion-icon style="font-size: 40px" :icon="call"></ion-icon>
      </div>
      <ion-button
        class="ion-margin-top gtm-call-medgate"
        fill="outline"
        @click="window.open('tel:+498959123456')"
        >Jetzt anrufen</ion-button
      >
      <div class="ion-margin-top">
        Sie verlassen jetzt die Roodie App und werden direkt zu
        <a
          href="#"
          @click.prevent="
            $router.push({
              name: 'medgate',
              params: { from: 'contact' },
            });
            modalController.dismiss();
          "
        >
          Medgate</a
        >, dem Spezialisten für Fernbehandlung, weitergeleitet.
        <br />
        Alles Gute für Ihre Genesung!
      </div>
    </div>
  </div>
</template>

<script>
import Roodie from "@lib/components/svg/Roodie";
import { IonButton, IonIcon, modalController } from "@ionic/vue";
import { call } from "ionicons/icons";
import ModalClose from "@lib/components/ModalClose";

export default {
  components: {
    Roodie,
    IonButton,
    IonIcon,
    ModalClose,
  },
  setup() {
    return { call, modalController };
  },
  data() {
    return {
      window: window,
    };
  },
};
</script>

<style></style>
